import { createSlice } from "@reduxjs/toolkit";

const tabsSlice = createSlice({
  name: "tabs",
  initialState: {activeTab: ""},
  reducers: {
    changeTab(state, action) {
      state.activeTab = action.payload;
    },
  },
});

export const tabsActions = tabsSlice.actions;

export default tabsSlice;
